module.exports = __webpack_public_path__ + "static/bar04_1-50a5f4faf143f935a44c329639c02237.png";